// Centralized configuration for the SignalCue web application
// The API URL is injected at build time via environment variables.

export const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname.includes('-staging') 
    ? 'https://signalcue-api-staging-790924719842.asia-southeast1.run.app' 
    : 'https://signalcue-api-790924719842.asia-southeast1.run.app');
export const APP_URL = process.env.REACT_APP_APP_URL || (window.location.hostname.includes('-staging') ? window.location.origin : 'https://app.signalcue.ai');
export const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || (window.location.hostname.includes('-staging') ? window.location.origin : 'https://signalcue.ai');

console.log('SignalCue config loaded:', {
    API_BASE_URL,
    APP_URL,
    LOGIN_URL,
    NODE_ENV: process.env.NODE_ENV
});
